<div class="logo">
  <img src="assets/logo.png">
</div>

<div class="center">
  <mat-card class="form">
    <form class="example-form" [formGroup]="registerForm">
      <mat-form-field class="example-full-width">
        <mat-label>Email Adresse</mat-label>
        <input matInput type="email" formControlName="email" class="form-control" placeholder="xyz@iubh-fernstudium.de">
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Passwort</mat-label>
        <input matInput type="password" class="form-control" formControlName="password" required>
      </mat-form-field>
      <div class="center">
        <button mat-stroked-button type="submit" (click)="tryRegister(registerForm.value)" class="btn btn-default button">REGISTRIEREN</button>
      </div>
      <br />
      <mat-label class="error">{{errorMessage}}</mat-label>
      <mat-label class="success">{{successMessage}}</mat-label>
    </form>
  </mat-card>
</div>
<div class="row center">
  <div class="col-md-4 col-md-offset-4">
    <p class="center"><a href="/login">Zum Login</a></p>
  </div>
</div>

